import { TokenAmount } from '@uniswap/sdk-core'
import { FeeAmount } from '@uniswap/v3-sdk'
import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import DoubleCurrencyLogo from 'components/DoubleLogo'
import FeeSelector from 'components/FeeSelector'
import { PositionPreview } from 'components/PositionPreview'
import { RowBetween } from 'components/Row'
import Tag from 'components/Tag'
import { CurrencyDropdown, StepReview } from 'pages/AddLiquidity/styled'
import React from 'react'
import { Field } from 'state/mint/actions'
import { TYPE } from 'theme'

const FeeLabel = {
  [FeeAmount.LOWER]: '0.01%',
  [FeeAmount.LOW]: '0.05%',
  [FeeAmount.MEDIUM]: '0.3%',
  [FeeAmount.HIGH]: '1%',
}

interface Step0Props {
  activeStep: number
  hasExistingPosition: boolean
  existingPosition?: any
  outOfRange: boolean
  currencyA?: any
  currencyB?: any
  currencies: Record<string, any>
  formattedAmounts: Record<string, string>
  maxAmounts: Record<string, any>
  atMaxAmounts: { [field in Field]?: TokenAmount }
  onFieldAInput: (val: string) => void
  onFieldBInput: (val: string) => void
  handleCurrencyASelect: (currency: any) => void
  handleCurrencyBSelect: (currency: any) => void
  feeAmount?: FeeAmount
  handleFeePoolSelect: (fee: number) => void
  step0Validate: boolean
  handleStep: (step: number) => void
}
const Step0: React.FC<Step0Props> = ({
  activeStep,
  hasExistingPosition,
  existingPosition,
  outOfRange,
  currencyA,
  currencyB,
  currencies,
  formattedAmounts,
  maxAmounts,
  atMaxAmounts,
  onFieldAInput,
  onFieldBInput,
  handleCurrencyASelect,
  handleCurrencyBSelect,
  feeAmount,
  handleFeePoolSelect,
  step0Validate,
  handleStep,
}) => {
  return (
    <>
      {activeStep === 0 && (
        <>
          {!hasExistingPosition && (
            <>
              <AutoColumn gap="md">
                <RowBetween paddingBottom="20px">
                  <TYPE.label>Select pair</TYPE.label>
                </RowBetween>
                <RowBetween>
                  <CurrencyDropdown
                    value={formattedAmounts[Field.CURRENCY_A]}
                    onUserInput={onFieldAInput}
                    hideInput={true}
                    onMax={() => {
                      onFieldAInput(maxAmounts[Field.CURRENCY_A]?.toExact() ?? '')
                    }}
                    onCurrencySelect={handleCurrencyASelect}
                    showMaxButton={!atMaxAmounts[Field.CURRENCY_A]}
                    currency={currencies[Field.CURRENCY_A]}
                    id="add-liquidity-input-tokena"
                    showCommonBases
                  />
                  <div style={{ width: '12px' }}></div>

                  <CurrencyDropdown
                    value={formattedAmounts[Field.CURRENCY_B]}
                    hideInput={true}
                    onUserInput={onFieldBInput}
                    onCurrencySelect={handleCurrencyBSelect}
                    onMax={() => {
                      onFieldBInput(maxAmounts[Field.CURRENCY_B]?.toExact() ?? '')
                    }}
                    showMaxButton={!atMaxAmounts[Field.CURRENCY_B]}
                    currency={currencies[Field.CURRENCY_B]}
                    id="add-liquidity-input-tokenb"
                    showCommonBases
                  />
                </RowBetween>
              </AutoColumn>
            </>
          )}
          <>
            {hasExistingPosition && existingPosition ? (
              <PositionPreview position={existingPosition} title={'Selected Range'} inRange={!outOfRange} />
            ) : (
              <>
                <FeeSelector
                  disabled={!currencyB || !currencyA}
                  currencies={currencies}
                  feeAmount={feeAmount}
                  handleFeePoolSelect={handleFeePoolSelect}
                />
              </>
            )}
          </>

          <ButtonPrimary disabled={!step0Validate} onClick={() => handleStep(1)}>
            Continue
          </ButtonPrimary>
        </>
      )}

      {activeStep > 0 && step0Validate && (
        <StepReview style={{ marginTop: '12px' }}>
          <span className="title">Step 1</span>
          <div className="value">
            <DoubleCurrencyLogo
              currency0={currencies.CURRENCY_A ?? undefined}
              currency1={currencies.CURRENCY_B ?? undefined}
              size={16}
              margin={true}
            />
            <TYPE.label ml="8px" fontSize="14px">
              {currencies.CURRENCY_A?.symbol} / {currencies.CURRENCY_B?.symbol}
            </TYPE.label>
            <div style={{ marginLeft: '10px' }}>
              <Tag variant={2}>{feeAmount && FeeLabel[feeAmount]}</Tag>
            </div>
          </div>
          <button onClick={() => handleStep(0)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
              <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
              <path d="M16 5l3 3" />
            </svg>
            Edit
          </button>
        </StepReview>
      )}
    </>
  )
}
export default React.memo(Step0)
